__turbopack_context__.v({
  "code": "CodeContent-module__UoCm7G__code",
  "codeBlock": "CodeContent-module__UoCm7G__codeBlock",
  "container": "CodeContent-module__UoCm7G__container",
});
